import React from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Store } from "lucide-react";
import { DynamicModule } from "@/components/modules/DynamicModule";

// Phase 86 — rendu d'un module sur mesure côté gérant (/chef/modules/:key).
export default function ChefModulePage() {
  const { key } = useParams();
  const [params] = useSearchParams();
  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="chef-module-page" data-module={key}>
      <DynamicModule key={key} moduleKey={key} initialEntity={params.get("entity") || undefined}
        errorAction={<Link to="/chef/marketplace?kind=module" className="inline-flex items-center gap-1 text-xs font-bold underline" data-testid="chef-module-back-catalog"><Store className="h-3.5 w-3.5" />Voir la Marketplace</Link>} />
    </div>
  );
}
